export default function (context, {value, name, field}) {
    let setting = context.state[name];
    setting[field] = value;
}